import { StepType } from 'src/graphql/types/steps'

const DQFSteps = [
  StepType.MVR,
  StepType.PSP,
  StepType.CDL,
  StepType.CDLIS,
  StepType.BACKGROUND_CHECK,
  StepType.CLEARINGHOUSE,
  StepType.DOT_MEDICAL,
  StepType.VERIFICATION_OF_EMPLOYMENT,
  StepType.DRUG_AND_ALCOHOL_TESTING,
  StepType.ROAD_TEST,
]

export const DEFAULT_STEP_ORDER = [StepType.DOT_APP, ...DQFSteps]

type SortableStep = {
  type?: string | null
  customStepId?: string | null
}

type StepOrderJobListing = {
  jobListingTemplate?: {
    steps?: {
      stepType?: string | null
      customStepId?: string | null
      order: number
    }[]
  } | null
} | null

const stepKey = (step: SortableStep) => step.customStepId ?? step.type

export const sortStepsByTemplate = <T extends SortableStep>(
  steps: T[],
  jobListing: StepOrderJobListing
): T[] => {
  const templateSteps = jobListing?.jobListingTemplate?.steps
  if (templateSteps && templateSteps.length > 0) {
    const orderMap = new Map(
      [...templateSteps]
        .sort((a, b) => a.order - b.order)
        .map((ts, index) => [ts.customStepId ?? ts.stepType, index])
    )
    return [...steps].sort((a, b) => {
      const aOrder = orderMap.get(stepKey(a)) ?? Number.MAX_SAFE_INTEGER
      const bOrder = orderMap.get(stepKey(b)) ?? Number.MAX_SAFE_INTEGER
      return aOrder - bOrder
    })
  }

  const orderMap = new Map(
    DEFAULT_STEP_ORDER.map((stepType, index) => [stepType, index])
  )
  return [...steps].sort((a, b) => {
    const aOrder = orderMap.get(a.type as StepType) ?? Number.MAX_SAFE_INTEGER
    const bOrder = orderMap.get(b.type as StepType) ?? Number.MAX_SAFE_INTEGER
    return aOrder - bOrder
  })
}
